import { IconBuilding16, IconCar16, IconPinMarker16, IconPlaneLand16, IconPlaneTakeOff16 } from '@warp-ds/icons/react';

import type { AutocompleteOption, AutocompleteProps } from '../../../types';

interface AutocompleteIconProps {
    option: AutocompleteOption | null;
    vertical: AutocompleteProps['vertical'];
    departure?: AutocompleteProps['departure'];
    className?: string;
}

export const AutocompleteIcon = ({ option, vertical, className, departure = true }: AutocompleteIconProps) => {
    const iconProps = { 'aria-hidden': true, className, focusable: false };

    if (vertical === 'flight' && option?.locationType === 'CITY') {
        return <IconPinMarker16 {...iconProps} />;
    }

    if (vertical === 'flight' && departure === false) {
        return <IconPlaneLand16 {...iconProps} />;
    }

    if (vertical === 'hotel' && option?.type === 'hotel') {
        return <IconBuilding16 {...iconProps} />;
    }

    if (vertical === 'car' && option?.type === 'Flyplass') {
        return departure ? <IconPlaneTakeOff16 {...iconProps} /> : <IconPlaneLand16 {...iconProps} />;
    }

    if (vertical === 'car' && option?.type === 'By / Område') {
        return <IconPinMarker16 {...iconProps} />;
    }

    switch (vertical) {
        case 'flight':
            return <IconPlaneTakeOff16 {...iconProps} />;
        case 'hotel':
            return <IconPinMarker16 {...iconProps} />;
        case 'car':
            return <IconCar16 {...iconProps} />;
        case 'prepackage':
            return <IconPinMarker16 {...iconProps} />;
        case 'fhh':
            return <IconPinMarker16 {...iconProps} />;
        default:
            return null;
    }
};
